import { render, staticRenderFns } from "./generateResults.vue?vue&type=template&id=36c4b928&scoped=true"
import script from "./generateResults.vue?vue&type=script&lang=js"
export * from "./generateResults.vue?vue&type=script&lang=js"
import style0 from "./generateResults.vue?vue&type=style&index=0&id=36c4b928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4b928",
  null
  
)

export default component.exports